import React from 'react'
import { Col } from 'react-bootstrap-five'
import Nav from 'react-bootstrap-five/Nav'

type Props = {
  children: React.ReactNode
}

const ContentNavigation: React.FC<Props> = ({ children }) => {
  return (
    <Col className="p-0" md="2">
      <Nav className="flex-column border-none">{children}</Nav>
    </Col>
  )
}

export default ContentNavigation
